// src/pages/Loja/singleProduct.js corrigido
import React from 'react';
import { useDispatch } from 'react-redux';
import { adicionarItem } from './../../redux/cartReducer';

export default function SingleProduct({ produto }) {
  const dispatch = useDispatch();

  const adicionarAoCarrinho = () => {
    dispatch(adicionarItem({ nome: produto.titulo, preco: parseFloat(produto.preco) }));
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold mb-2">{produto.titulo}</h1>
      <p className="mb-2">{produto.descricao}</p>
      <p className="text-green-700 font-bold mb-4">R$ {parseFloat(produto.preco).toFixed(2)}</p>

      <button
        onClick={adicionarAoCarrinho}
        className="px-6 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
      >
        Adicionar ao Carrinho
      </button>
    </div>
  );
}
